import { SessionContext } from '@contexts/session-context';
import { SubscriptionStatus } from '@enums/subscription-status.enum';
import SessionService from '@services/session.service';
import { Button, Icon, Modal, useTranslation } from '@testsigma/atoms';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const TrailExpired = () => {
  const { session } = useContext(SessionContext);
  const [showExpiredModal, setShowExpiredModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const logout = () => {
    SessionService.logout(true);
  };
  const url = window.location.href;
  const isBilling = url.includes('settings/billing');
  const isPaused =
    session?.tenant?.subscription?.status == SubscriptionStatus.PAUSED;
  const isCancelled =
    session?.tenant?.subscription?.status == SubscriptionStatus.CANCELLED;

  useEffect(() => {
    if (session?.tenant?.subscription?.status) {
      const isCanclled = [
        SubscriptionStatus.CANCELLED,
        SubscriptionStatus.PAUSED,
      ].includes(session?.tenant?.subscription?.status);
      if (isCanclled && !isBilling) {
        setShowExpiredModal(true);
      }
    }
  }, [session, url]);

  return (
    <Modal isOpen={showExpiredModal} className='w-[600px]'>
      <div className='flex items-start'>
        <div className='flex items-center p-2 rounded-[40px] bg-error-50 w-[58px] mb-4 mr-6'>
          <Icon
            name='error'
            className='text-2xl flex w-[40px] text-error-600 p-2 bg-error-100 rounded-3xl'
          />
        </div>
        <div className='text-neutral-700 flex flex-col'>
          {isCancelled && (
            <>
              <h1 className='text-lg text-secondary-unique-600 font-semibold mb-2'>
                {t('billing.plan.trail_expired.header')}
              </h1>
              <div className='text-sm text-secondary-500 font-normal mb-6'>
                {t(
                  session.user.isAdmin
                    ? 'billing.plan.trail_expired.content'
                    : 'billing.plan.trail_expired_user',
                )}
              </div>
            </>
          )}

          {isPaused && (
            <>
              <h1 className='text-lg text-secondary-unique-600 font-semibold mb-2'>
                {t('subscription_paused_notification.title')}
              </h1>
              <div className='text-sm text-secondary-500 font-normal mb-6'>
                {t(
                  session.user.isAdmin
                    ? 'subscription_paused_notification.tag_line'
                    : 'billing.plan.trail_expired_user',
                )}
              </div>
            </>
          )}
          {session.user.isAdmin ? (
            <>
              <div className='flex mb-6'>
                {isCancelled && (
                  <Button
                    type='primary'
                    onClick={() => {
                      setShowExpiredModal(false);
                      navigate('/settings/billing');
                    }}
                  >
                    {t('billing.plan.action_subscribe')}
                  </Button>
                )}
                {isPaused && (
                  <Button
                    type='primary'
                    onClick={() => {
                      setShowExpiredModal(false);
                      navigate('/settings/billing');
                    }}
                  >
                    {t('subscription_paused_notification.pay_now')}
                  </Button>
                )}
              </div>
              {isCancelled && (
                <div className='text-sm text-secondary-500 font-normal mb-4'>
                  {t('billing.plan.trail_expired_help')}
                </div>
              )}
              {isPaused && (
                <div className='text-sm text-secondary-500 font-normal mb-4'>
                  {t('subscription_paused_notification.help')}
                </div>
              )}

              <div className='flex items-center gap-3'>
                <Button
                  type='secondary'
                  className='flex items-center w-[230px] justify-center py-2'
                  onClick={() => (window as any)?.fcWidget?.open()}
                >
                  <Icon name='chat' className='text-sm mr-2' />
                  {t('billing.plan.chat_with_us')}
                </Button>
                <Button
                  type='secondary'
                  className='flex items-center w-[230px] justify-center py-2'
                  onClick={() =>
                    window.open(
                      `mailto::${t(
                        'mailboxes.empty-state-description.support',
                      )}`,
                      '_blank',
                    )
                  }
                >
                  <Icon name='forward-to-inbox' className='text-sm mr-2' />
                  {t('billing.plan.support')}
                </Button>
              </div>
            </>
          ) : (
            <div className='flex mb-6'>
              <Button type='primary' onClick={() => logout()}>
                {t('left.nav.logout')}
              </Button>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TrailExpired;
